import {css} from 'lit';
export const styles = css`:host {
  --progress-bar-height: 6px;
  --progress-bar-margin: 8px 0 8px 0;
  --progress-bar-color: var(--primary);
  --progress-bar-color-disabled: var(--gray-500);
  --progress-bar-box-shadow: none;
  --progress-bar-value-border-radius: 100px;
  --progress-bar-value-box-shadow: none;
  --button-size: 22px;
  --button-border: 2px solid var(--button-color);
  --button-border-radius: 50%;
  --button-icon-size: 13px;
  --count-label-display: inline;
  --button-padding: 1px 0 0 0;
  --button-color-disabled: var(--gray-500);

  display: block;
  padding-top: 8px;
  padding-bottom: 8px;
}

:host([readOnlyOn]) {
  --button-icon-size: 24px;
}

:host([disabled]) {
  --progress-bar-color: var(--progress-bar-color-disabled);
}

ef-progress-bar {
  --info: var(--progress-bar-color);
  --value-border-radius: var(--progress-bar-value-border-radius);
  --value-box-shadow: var(--progress-bar-value-box-shadow);

  overflow: hidden;
  margin: var(--progress-bar-margin);
  box-shadow: var(--progress-bar-box-shadow);
  height: var(--progress-bar-height);
}

:host([layout='column']) .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

:host([layout='column']) .right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

:host([layout='column']) .left {
    margin-right: 16px;
  }

:host([layout='row']) .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

:host([layout='row']) .left {
    display: flex;
    align-items: center;
  }
`;
export default styles;
